// extracted by mini-css-extract-plugin
export default {"lineClamp":"fBr0MZt_64PTA8Rhcxhg","gap":"QFWMCX5fFZ1aVS_QYygT","skeleton":"rMatJx6wMEpu5xAxdXed","pulse":"RGwrT7kpR2W0JvzB4EUy","table-striped":"sBxU6ujxRcgtDcuI16e4"};